import { Experiment } from '@grammarly/experimentation-js-sdk'
import { serverExperimentsConfig } from './server-experiments'

export type ServerExperimentConfig = {
  id: string
  variants: readonly string[]
}

function createExperiments<T extends Record<string, ServerExperimentConfig>>(config: T) {
  const experiments: Record<string, Experiment> = {}

  for (const key in config) {
    const { id, variants } = config[key]
    experiments[key] = new Experiment(id, [...variants])
  }

  return experiments as {
    [K in keyof T]: Experiment<T[K]['variants'][number]>
  }
}

export const ServerAssignedExperiments = createExperiments(serverExperimentsConfig)
